import React, { useEffect, useState } from "react";
import {
  Select,
  Table,
  DatePicker,
  Modal,
  Button,
  Typography,
  Tag,
  Descriptions,
  Divider,
  Space,
  Image,
} from "antd";
import {
  ClockCircleOutlined,
  SyncOutlined,
  CheckCircleOutlined,
  AppstoreOutlined,
} from "@ant-design/icons";
import Slider from "react-slick";
import Header from "../../common/Header";
import search_icn from "../../../assets/images/search-1.svg";
import cross_icn from "../../../assets/images/cross.svg";
import "./complaints.scss";

const { RangePicker } = DatePicker;

const PriorityTag = ({ priority }) => {
  let color;
  switch (priority?.toLowerCase()) {
    case "high":
      color = "volcano";
      break;
    case "medium":
      color = "orange";
      break;
    case "low":
      color = "geekblue";
      break;
    default:
      color = "default";
  }
  return <Tag color={color}>{priority?.toUpperCase()}</Tag>;
};

const statusConfig = {
  pending: { icon: <ClockCircleOutlined />, label: "Pending" },
  "in-progress": { icon: <SyncOutlined spin />, label: "In Progress" },
  resolved: { icon: <CheckCircleOutlined />, label: "Resolved" },
};

const styles = {
  ticketDetailsModal: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  ticketHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
  },
  ticketDescriptionSection: {
    display: "flex",
    flexDirection: "column",
  },
  descriptionContentBox: {
    whiteSpace: "pre-wrap",
    backgroundColor: "#f7f7f7",
    padding: "12px",
    borderRadius: "6px",
    marginTop: "8px",
    border: "1px solid #e8e8e8",
    maxHeight: "200px",
    overflowY: "auto",
  },
  descriptionParagraph: {
    marginBottom: "0",
  },
  ticketStatusSection: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#fafafa",
    padding: "16px",
    borderRadius: "8px",
    border: "1px solid #e8e8e8",
  },
  attachmentsSection: {
    display: "flex",
    flexDirection: "column",
  },
  carouselContainer: {
    marginTop: "8px",
    borderRadius: "4px",
    overflow: "hidden",
  },
};

const ComplaintsComponent = (props) => {
  const {
    handelComplaintStatusType,
    complaintFilters = {},
    handleFilterDateChange,
    societies_table_columns,
    complaint_table_data,
    setSearchText,
    complaint_count,
    handelComplaintFilterClear,
    searchText,
    rangeValue,
    isClearButtonDisabled,
    isModalVisible,
    selectedTicket,
    handleModalCancel,
    handleStatusChange,
  } = props;

  const isVideo = (url) => {
    const videoExtensions = [".mp4", ".mov", ".webm", ".ogg"];
    return videoExtensions.some((ext) => url.toLowerCase().includes(ext));
  };

  const useImageBlobs = (attachments) => {
    const [blobs, setBlobs] = useState([]);

    useEffect(() => {
      if (!attachments || attachments.length === 0) {
        setBlobs([]);
        return;
      }

      const fetchBlobs = async () => {
        const results = await Promise.all(
          attachments.map(async (url) => {
            if (isVideo(url)) {
              return url;
            }
            try {
              const response = await fetch(url);
              const blob = await response.blob();
              return URL.createObjectURL(blob);
            } catch (err) {
              return url;
            }
          })
        );
        setBlobs(results);
      };

      fetchBlobs();
    }, [attachments]);

    return blobs;
  };

  const attachments = useImageBlobs(selectedTicket?.attachments || []);

  return (
    <React.Fragment>
      <Header title="Help Desk" />
      <div className="complaints-main">
        <div className="complaints-first">
          <div className="left-section">
            <h1>Help Desk Tickets</h1>
            <p className="dec-text">
              Monitor society complaints with essential details and filtering
              for streamlined resolution.
            </p>
          </div>
          <div className="right-section">
            <div className="card-11 card">
              <AppstoreOutlined
                style={{ fontSize: "36px", color: "#d7868e" }}
              />
              <div className="details">
                <h1>{complaint_count?.total_help_desk_tickets || 0}</h1>
                <p>Total Tickets</p>
              </div>
            </div>
            <div className="card-12 card">
              <ClockCircleOutlined
                style={{ fontSize: "36px", color: "#ee5766" }}
              />
              <div className="details">
                <h1>{complaint_count?.pending_help_desk_tickets || 0}</h1>
                <p>Pending Tickets</p>
              </div>
            </div>
            <div className="card-13 card">
              <SyncOutlined style={{ fontSize: "36px", color: "#1890ff" }} />
              <div className="details">
                <h1>{complaint_count?.in_progress_help_desk_tickets || 0}</h1>
                <p>In-Progress Tickets</p>
              </div>
            </div>
            <div className="card-14 card">
              <CheckCircleOutlined
                style={{ fontSize: "36px", color: "#52c41a" }}
              />
              <div className="details">
                <h1>{complaint_count?.resolved_help_desk_tickets || 0}</h1>
                <p>Resolved Tickets</p>
              </div>
            </div>
          </div>
        </div>
        {/* filters row */}
        <div className="complaints-second">
          <div className="left-section">
            <div className="search-box">
              <img src={search_icn} alt="Search" className="search-icon" />

              <input
                type="text"
                placeholder="Search by Complaint..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                style={{
                  flex: 1,

                  border: "none",

                  outline: "none",

                  fontSize: "16px",

                  color: "#333",

                  background: "transparent",
                }}
              />

              {searchText && (
                <button onClick={() => setSearchText("")}>
                  <img src={cross_icn} alt="clear" className="clear-icon" />
                </button>
              )}
            </div>

            <Select
              className="select-status"
              placeholder="Complaint Status"
              onChange={handelComplaintStatusType}
              value={complaintFilters.current_status}
              filterOption={(input, option) =>
                option.value.toLowerCase().includes(input.toLowerCase())
              }
              allowClear
            >
              <Select.Option value="pending">Pending</Select.Option>

              <Select.Option value="in-progress">In Progress</Select.Option>

              <Select.Option value="resolved">Resolved</Select.Option>
            </Select>
          </div>
          <div className="right-section">
            <RangePicker
              picker="date"
              className="range-picker"
              onChange={handleFilterDateChange}
              value={rangeValue}
            />
            <button
              onClick={handelComplaintFilterClear}
              disabled={isClearButtonDisabled}
            >
              Clear
            </button>
          </div>
        </div>
        {/* table */}
        <div className="complaints-list">
          <Table
            dataSource={complaint_table_data}
            columns={societies_table_columns}
            pagination={{
              position: ["bottomCenter"],
              showSizeChanger: true,
              pageSizeOptions: ["10", "25", "50", "100"],
              defaultPageSize: 10,
            }}
            scroll={{ x: "max-content" }}
            className="society-table"
          />
        </div>
      </div>

      {/* modal */}
      {selectedTicket && (
        <Modal
          title={`Ticket Details: #${selectedTicket?._id}`}
          open={isModalVisible}
          onCancel={handleModalCancel}
          footer={[
            <Button key="close" onClick={handleModalCancel}>
              Close
            </Button>,
          ]}
          width={700}
          centered
          styles={{
            body: {
              maxHeight: "calc(100vh - 200px)",
              overflowY: "auto",
            },
          }}
        >
          <div style={styles.ticketDetailsModal}>
            <div style={styles.ticketHeader}>
              <Typography.Title
                level={4}
                style={{ margin: 0, maxWidth: "80%" }}
              >
                {selectedTicket.title}
              </Typography.Title>
              <PriorityTag priority={selectedTicket.priority} />
            </div>

            <Divider style={{ margin: "12px 0" }} />
            <Descriptions bordered column={2} size="small">
              <Descriptions.Item label="Society Name">
                {selectedTicket.societyName}
              </Descriptions.Item>
              <Descriptions.Item label="Submitted By">
                {selectedTicket.owner}
              </Descriptions.Item>
              <Descriptions.Item label="Date Submitted" span={2}>
                {new Date(selectedTicket.createdAt).toLocaleString()}
              </Descriptions.Item>
            </Descriptions>

            <Divider style={{ margin: "12px 0" }} />
            <div style={styles.ticketDescriptionSection}>
              <Typography.Text strong>Description</Typography.Text>
              <div style={styles.descriptionContentBox}>
                <Typography.Paragraph style={styles.descriptionParagraph}>
                  {selectedTicket.description}
                </Typography.Paragraph>
              </div>
            </div>

            {attachments.length > 0 && (
              <>
                <Divider style={{ margin: "12px 0" }} />
                <div style={styles.attachmentsSection}>
                  <Typography.Text strong>Attachments</Typography.Text>
                  <div style={{ marginTop: "12px" }}>
                    <Slider
                      dots
                      arrows
                      slidesToShow={1}
                      slidesToScroll={1}
                      infinite={false}
                    >
                      {attachments.map((src, index) => (
                        <div
                          key={index}
                          className="attachment-container"
                          style={{
                            width: "100%",
                            display: "flex !important",
                            justifyContent: "center",
                            alignItems: "center !important",
                          }}
                        >
                          {isVideo(src) ? (
                            <video
                              src={src}
                              style={{
                                borderRadius: "8px",
                                width: "100%",
                                maxWidth: "80%",
                                margin: "0 auto",
                                display: "block",
                                height: "100%",
                                maxHeight: "220px",
                                objectFit: "cover",
                              }}
                              controls
                              crossOrigin="anonymous"
                            />
                          ) : (
                            <Image
                              src={src}
                              alt={`attachment-${index}`}
                              style={{
                                borderRadius: "8px",
                                width: "100%",
                                margin: "0 auto",
                                display: "block",
                                objectFit: "cover",
                                maxWidth: "50%",
                              }}
                              preview={false}
                              crossOrigin="anonymous"
                              fallback="https://placehold.co/200x120/F0F0F0/BDBDBD?text=No+Image"
                            />
                          )}
                        </div>
                      ))}
                    </Slider>
                  </div>
                </div>
              </>
            )}

            <Divider style={{ margin: "12px 0" }} />
            <div style={styles.ticketStatusSection}>
              <Typography.Text strong style={{ marginRight: "16px" }}>
                Status:
              </Typography.Text>
              <Select
                value={selectedTicket.current_status}
                style={{ width: 180 }}
                onChange={(value) =>
                  handleStatusChange(value, selectedTicket._id)
                }
              >
                {Object.entries(statusConfig).map(([key, { icon, label }]) => (
                  <Select.Option key={key} value={key}>
                    <Space>
                      {icon}
                      {label}
                    </Space>
                  </Select.Option>
                ))}
              </Select>
            </div>
          </div>
        </Modal>
      )}
    </React.Fragment>
  );
};

export default ComplaintsComponent;
